import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import NProgress from "nprogress";

const DEFAULT_TITLE = "Donate Badges";

const routes = [
  {
    path: "/",
    alias: ["/index.html"],
    name: "home",
    component: HomeView,
  },
  {
    path: "/generate",
    name: "generate",
    meta: {
      title: "Generate",
    },
    component: () =>
      import(/* webpackChunkName: "generate" */ "../views/GenerateView.vue"),
  },
  {
    path: "/donate/:category/:address",
    name: "donate",
    meta: {
      title: "Donate",
    },
    component: () =>
      import(/* webpackChunkName: "donate" */ "../views/DonateView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
  },
});

NProgress.configure({ showSpinner: false });

// eslint-disable-next-line no-unused-vars
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }

  next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = "Donate Badges - " + to.meta.title || DEFAULT_TITLE;
  } else {
    document.title = DEFAULT_TITLE;
  }

  NProgress.done();
});

export default router;
